export default __webpack_public_path__ + "media/images/logo-symbol-icon-74f13f6627d75d2735d05ccd6223a59d.svg";